const chooseHouse = document.querySelector('.choose-house');

if (chooseHouse) {
  const chooseHouseLink = chooseHouse.querySelector('.choose-house__submit');
  const setParamsForLink = () => {
    if (!chooseHouseLink) {
      return;
    }

    const data = {
      models: chooseHouse.querySelector('input[name="select_roof"]:checked')?.value,
      rangeStart: chooseHouse.querySelector('#range_start').value,
      rangeEnd: chooseHouse.querySelector('#range_end').value,
      rooms: chooseHouse.querySelector('input[name="house_list_rooms"]:checked')?.value,
    };

    const originalHref = chooseHouseLink.getAttribute('data-original-href') || '';
    const [hrefWithoutHash, hash] = originalHref.split('#');
    const baseUrl = hrefWithoutHash.split('?')[0];

    const query = Object.entries(data)
      .filter(([, val]) => val)
      .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
      .join('&');

    chooseHouseLink.setAttribute('href', `${baseUrl}${query ? `?${query}` : ''}${hash ? `#${hash}` : ''}`);
  };
  attachEvent(
    '.choose-house .radio-button-group__list input, .choose-house .choose-house__roofs-item input',
    'change',
    () => {
      setParamsForLink();
    },
  );

  attachEvent('.choose-house #range_start, .choose-house #range_end', 'input', () => {
    setParamsForLink();
  });
}
